import { combineReducers } from "redux";

import alert from "./alert";
import embed from "./embed";
import form from "./form";
import status from "./status";
import ui from "./ui";
import revisions from "./revisions";

export default combineReducers({
  alert,
  embed,
  form,
  status,
  ui,
  revisions,
});
